





















import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PolicyStatus } from 'admiral-core';
import { Util } from '@/utils/Util';
import PolicyStatusBadge from '@/components/common/PolicyStatusBadge.vue';

@Component({
  name: 'policy-status-checkbox',
  components: { PolicyStatusBadge },
})
export default class PolicyStatusCheckbox extends Vue {
  @Prop({ required: false, type: String })
  status!: PolicyStatus;

  @Prop({ required: false, type: Boolean, default: false })
  checked!: boolean;

  get label() {
    return Util.formatPolicyStatus(this.status);
  }
  change() {
    this.$emit('update', {
      status: this.status,
      value: !this.checked,
    });
  }
}
